import { lazy } from "react";
import { paths } from "./path";
import ContactUs from "../pages/ContectUs";
import CareersPage from "../pages/CareersPage";

const Home = lazy(() => import("../pages/Home"));
const AboutPage = lazy(() => import("../pages/AboutPage"));
const OurProduct = lazy(() => import("../pages/OurProduct"));
const OurProduct1 = lazy(() => import("../pages/OurProduct1"));
const OtherBusinessLoan = lazy(() =>
  import("../pages/loans/OtherBusinessLoan")
);
const UsedBusinessLoan = lazy(() =>
  import("../pages/loans/UsedBusinessLoan")
);
const UsedTractorFinance = lazy(() =>
  import("../pages/loans/UsedTractorFinance")
);
const CommercialVehicleLoan = lazy(() =>
  import("../pages/loans/CommercialVehicleLoan")
);

const CustomerGrievancePage = lazy(() =>
  import("../pages/CustomerGrievancePage")
);
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const ConstructorEquipment = lazy(() =>
  import("../pages/loans/ConstructorEquipment")
);
const TwoWheeler = lazy(() => import("../pages/loans/TwoWheeler"));
const Carloan = lazy(() => import("../pages/loans/Carloan"));
const EVCarLoan = lazy(() => import("../pages/loans/EVCarLoan"));
const EV3WheelerLoan = lazy(() => import("../pages/loans/EV3WheelerLoan"));
const EVTruckLoan = lazy(() => import("../pages/loans/EVTruckLoan"));
const HousePurchase = lazy(() => import("../pages/loans/HousePurchase"));
const HouseConstruction = lazy(() =>
  import("../pages/loans/HouseConstruction")
);
const LoanAgainestProperty = lazy(() =>
  import("../pages/loans/LoanAgainestProperty")
);
const InsurenceAMC = lazy(() => import("../pages/loans/InsurenceAMC"));
const SpareParts = lazy(() => import("../pages/loans/SpareParts"));
const PersonalLoan = lazy(() => import("../pages/loans/PersonalLoan"));
const EmiCalculatorPage = lazy(() => import("../pages/EmiCalculatorPage"));
const Page404 = lazy(() => import("../pages/Page404"));

export const dashboardRoutes = [
  { path: paths.dashboard.root, element: <Home /> },

  {
    path: paths.dashboard.aboutUs,
    element: <AboutPage />,
  },
  {
    path: paths.dashboard.commercialVehicleLoan,
    element: <CommercialVehicleLoan />,
  },
  {
    path: paths.dashboard.customerGrievance,
    element: <CustomerGrievancePage />,
  },
  {
    path: paths.dashboard.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: paths.dashboard.termsAndConditions,
    element: <TermsAndConditions />,
  },

  {
    path: paths.dashboard.constructorEquipment,
    element: <ConstructorEquipment />,
  },
  {
    path: paths.dashboard.twoWheelerpage,
    element: <TwoWheeler />,
  },

  {
    path: paths.dashboard.carloan,
    element: <Carloan />,
  },
  {
    path: paths.dashboard.evCarLoan,
    element: <EVCarLoan />,
  },
  {
    path: paths.dashboard.ev3WheelerLoan,
    element: <EV3WheelerLoan />,
  },
  {
    path: paths.dashboard.evTruckLoan,
    element: <EVTruckLoan />,
  },
  {
    path: paths.dashboard.housePurchase,
    element: <HousePurchase />,
  },
  {
    path: paths.dashboard.houseConstruction,
    element: <HouseConstruction />,
  },
  {
    path: paths.dashboard.loanAgainestProperty,
    element: <LoanAgainestProperty />,
  },
  {
    path: paths.dashboard.insurenceAMC,
    element: <InsurenceAMC />,
  },
  {
    path: paths.dashboard.spareParts,
    element: <SpareParts />,
  },
  {
    path: paths.dashboard.personalLoan,
    element: <PersonalLoan />,
  },
  {
    path: paths.dashboard.contactUs,
    element: <ContactUs />,
  },
  {
    path: paths.dashboard.applicationForm,
    element: <ContactUs />,
  },
  {
    path: paths.dashboard.documentSubmission,
    element: <ContactUs />,
  },
  {
    path: paths.dashboard.requestCallBackForm,
    element: <ContactUs />,
  },
  {
    path: paths.dashboard.otherBusinessLoan,
    element: <OtherBusinessLoan />,
  },
  {
    path: paths.dashboard.usedBusinessLoan,
    element: <UsedBusinessLoan />,
  },
  {
    path: paths.dashboard.usedTractorFinance,
    element: <UsedTractorFinance />,
  },
  {
    path: paths.dashboard.ourProduct,
    element: <OurProduct />,
  },
  {
    path: paths.dashboard.ourProduct1,
    element: <OurProduct1 />,
  },
  {
    path: paths.dashboard.emiCalculator,
    element: <EmiCalculatorPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/404",
    element: <Page404 />,
  },
];
